export default {
    getPatientInfo(state){
        return state.patientInfo.data[0];
    },
    getPatientID(state) {
        return state.patient_id
    }
};
